import { PapiUserSelect } from "@bayerit/papi-react-components";
import { getAccessToken } from "../../config/api";

const BAYER_USERS = "https://profile.phoenix-tools-np.io/v3/graphql";

interface UserFieldProps {
  value: any; // Or a more specific type if you know it

  [key: string]: any; // Allow other props to be passed through
}

export const UserField = (props: any) => {
  return (
    <PapiUserSelect
      {...props}
      value={props.value}
      onChange={(selectedItem: any) => {
        props.onChange(selectedItem);
      }}
      size="medium"
      profileApiUrl={BAYER_USERS}
      tokenProvider={getAccessToken}
    />
  );
};
